<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-custom">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">Generate Sales e-Invoice (Non-VAT)</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-5">
              <!--              <ImportText fieldName="Address" fieldLabel="Address" :fieldModel="$v.form.Address.$model"></ImportText>-->

              <div>
                <b-form-group label="Branch" label-for="businessprofileid">
                  <b-form-select
                    v-model="$v.form.BusinessProfileId.$model"
                    :options="profiles"
                    :state="validateState('BusinessProfileId')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="businessprofileid"
                    placeholder="Revenue District Office"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    Branch is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Date" label-for="TransactionDate">
                  <b-input-group>
                    <b-form-input
                      v-model="$v.form.TransactionDateTime.$model"
                      :state="validateState('TransactionDateTime')"
                      name="Date"
                      type="text"
                      autocomplete="off"
                      v-mask="'####-##-##'"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      placeholder="YYYY-MM-DD"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="$v.form.TransactionDateTime.$model"
                        :state="validateState('TransactionDateTime')"
                        class="button-only-datepicker"
                        name="Date"
                        size="sm"
                        button-only
                        right
                        locale="en-US"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      Transaction Date is required.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
                <b-form-group label="Sold To" label-for="SoldTo">
                  <b-form-input
                    v-model="$v.form.Buyer.Name.$model"
                    :state="validateState('Name', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="SoldTo"
                    placeholder="Sold To"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Sold To is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Address" label-for="Address">
                  <b-form-textarea
                    v-model="$v.form.Buyer.Address.$model"
                    :state="validateState('Address', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    max-rows="8"
                    name="Address"
                    placeholder="Address"
                    rows="5"
                    size="sm"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    Address is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Buyer's TIN" label-for="TIN">
                  <b-form-input
                    v-model="$v.form.Buyer.TIN.$model"
                    v-mask="'###-###-###'"
                    :state="validateState('TIN', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="TIN"
                    placeholder="Buyer's TIN"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Buyer's TIN is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div>
                <button
                  :disabled="isBusy"
                  class="text-muted d-block"
                  type="button"
                  @click="addOscaPwd"
                >
                  <i class="flaticon2-add-square"></i> Add OSCA / PWD
                </button>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <h5>Items</h5>
              <div class="table-responsive">
                <table
                  class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover"
                >
                  <thead>
                    <tr class="text-uppercase">
                      <th style="width: 150px">Description</th>
                      <th style="width: 80px">Qty</th>
                      <th style="width: 80px">Unit</th>
                      <th style="width: 80px">Price</th>
                      <th style="width: 20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in form.Items" :key="item.Description">
                      <td style="width: 150px">
                        <span class="text-muted d-block">{{
                          item.Description
                        }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{
                          item.Quantity
                        }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{ item.Unit }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{ item.Price }}</span>
                      </td>
                      <td>
                        <button
                          :ref="'deleteItem_' + item.ProviderServiceId"
                          :disabled="isBusy"
                          class="text-muted d-block"
                          type="button"
                          @click="confirmDeleteItem(item)"
                        >
                          <i class="flaticon-delete"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-input
                          v-model="newItem.Description"
                          class="form-control"
                          placeholder="Description"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Quantity"
                          class="form-control"
                          placeholder="Qty"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Unit"
                          class="form-control"
                          placeholder="Unit"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Price"
                          class="form-control"
                          placeholder="Price"
                          type="number"
                        ></b-form-input>
                      </td>
                      <td>
                        <button
                          ref="submitItem"
                          :disabled="isBusy"
                          class="text-muted d-block"
                          type="button"
                          @click="addItem"
                        >
                          <i class="flaticon2-add-square"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5>Totals</h5>
              <div>
                <b-form-group label="Total Sales" label-for="TotalSales">
                  <b-form-input
                    v-model="$v.form.Totals.TotalSales.$model"
                    :state="validateState('TotalSales', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="TotalSales"
                    placeholder="Total Sales"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Sales is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <!--                <b-form-group label="Total Due" label-for="TotalDue">-->
                <!--                  <b-form-input v-model="$v.form.Totals.TotalDue.$model" :state="validateState('TotalDue', this.$v.form.Totals)" class="form-control form-control-solid h-auto py-3 px-3" name="TotalDue" placeholder="Total Due" size="sm"></b-form-input>-->
                <!--                  <b-form-invalid-feedback>-->
                <!--                    Total Due is required.-->
                <!--                  </b-form-invalid-feedback>-->
                <!--                </b-form-group>-->
                <b-form-group
                  label="Less: Deductions"
                  label-for="TotalDeductions"
                >
                  <b-form-input
                    v-model="$v.form.Totals.TotalDeductions.$model"
                    :state="
                      validateState('TotalDeductions', this.$v.form.Totals)
                    "
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="TotalDeductions"
                    placeholder="Total Deductions"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Deductions is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Total Amount" label-for="TotalAmount">
                  <b-form-input
                    v-model="$v.form.Totals.TotalAmount.$model"
                    :state="validateState('TotalAmount', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="TotalAmount"
                    placeholder="Total Amount"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Amount is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <h5>Payment</h5>
              <div>
                <b-form-group label="Form of Payment">
                  <b-form-radio-group
                    v-model="$v.form.FormOfPayment.$model"
                    :options="options.FormOfPayment"
                    :state="validateState('FormOfPayment')"
                    name="radio-options-FormOfPayment"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>
                    Form Of Payment is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  v-if="form.FormOfPayment !== 'Cash'"
                  :label="form.ReferenceNumber + 'Reference Number'"
                  label-for="ReferenceNumber"
                >
                  <b-form-input
                    v-model="$v.form.ReferenceNumber.$model"
                    :state="validateState('ReferenceNumber')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="ReferenceNumber"
                    placeholder="Reference Number"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Reference Number is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div class="card-footer">
          <div class="d-flex flex-wrap flex-center">
            <BackButton></BackButton>
            <button
              ref="submit"
              :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
              class="btn btn-primary mx-4"
              type="button"
              @click="submit"
            >
              Generate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import BackButton from "@/view/content/widgets/backbutton.vue";
import ApiService from "@/view/pages/easyreceipt/api";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
// import {ImportText} from '@/view/content/widgets/forms/inputtext.vue'

export default {
  mixins: [validationMixin],
  components: { BackButton },
  directives: { mask },
  props: ["propdata"],
  data() {
    return {
      isBusy: false, //isNew: false,
      form: {
        BusinessProfileId: "",
        SeriesType: "",
        Source: "",
        TransactionDateTime: "",
        Buyer: {
          Name: "",
          Address: "",
          TIN: ""
        },
        SeniorCitizen: {
          TIN: "",
          OSCAIdNumber: "",
          Discount: {
            Discounts: ""
          },
          Signature: ""
        },
        PersonWithDisability: {
          TIN: "",
          PwdIdNumber: "",
          Discount: {
            Discounts: ""
          }
        },
        Items: [],
        Totals: {
          //Quantity: "",
          TotalSales: "",
          TotalDeductions: "",
          TotalAmount: ""
        },
        FormOfPayment: "",
        ReferenceNumber: ""
      },
      profiles: [],
      newItem: {
        Description: "",
        Quantity: "",
        Unit: "",
        Price: ""
      },
      options: {
        FormOfPayment: [
          {
            text: "e-Payment",
            value: "e-Payment"
          },
          {
            text: "Check",
            value: "Check"
          },
          {
            text: "Cash",
            value: "Cash"
          },
          {
            text: "Others",
            value: "Others"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      BusinessProfileId: { required },
      TransactionDateTime: { required },
      Buyer: {
        Name: { required },
        Address: { required },
        TIN: { required }
      },
      SeniorCitizen: {
        TIN: {},
        OSCAIdNumber: {},
        Discount: {
          Discounts: {}
        },
        Signature: {}
      },
      PersonWithDisability: {
        TIN: {},
        PwdIdNumber: {},
        Discount: {
          Discounts: {}
        }
      },
      Items: [],
      Totals: {
        TotalSales: { required },
        TotalDeductions: { required },
        TotalAmount: { required }
      },
      FormOfPayment: { required },
      ReferenceNumber: {
        required: requiredIf(function() {
          return this.form.FormOfPayment !== "Cash";
        })
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    //console.log("clinics-createupdate.mounted");
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.setBreadcrumbs("Create");
      this.resetForm();
      this.getProfiles();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        },
        {
          title: "ATG",
          route: "/easyreceipt/atg"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name, container) {
      //console.log(name,container,  this.$v.form[name]);
      if (container) {
        const { $dirty, $error } = container[name];
        return $dirty ? !$error : null;
      } else {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    resetForm() {
      this.form = {
        BusinessProfileId: "",
        SeriesType: "Goods",
        Source: "Web",
        TransactionIdentifier: "",
        TransactionDateTime: "",
        MachineIdentificationNumber: "",
        Buyer: {
          Name: "",
          Address: "",
          TIN: ""
        },
        SeniorCitizen: {
          TIN: "",
          OSCAIdNumber: "",
          Discount: {
            Discounts: ""
          },
          Signature: ""
        },
        PersonWithDisability: {
          TIN: "",
          PwdIdNumber: "",
          Discount: {
            Discounts: ""
          }
        },
        Items: [],
        Totals: {
          TotalSales: "",
          TotalDeductions: "",
          TotalAmount: ""
        },
        FormOfPayment: "Cash"
      };
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    getProfiles() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/myprofiles", param)
          .then(({ data }) => {
            this.$gtag.event("business_myprofiles", param);
            self.profiles = data;
            if (data.length === 1) {
              self.form.BusinessProfileId = data[0].value;
            }
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    submit: function(e) {
      e.preventDefault();
      this.autoAddItem();
      if (this.form.Items.length === 0) return;
      this.postCreate();
    },
    postCreate() {
      let self = this;
      self.isBusy = true;
      let param = self.form;
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.put("sales/create", param)
        .then(({ data }) => {
          this.$gtag.event("sales_create", param);
          if (data) {
            self.isBusy = false;
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            this.$router.push({ name: "easyreceipt-sales-list" });
          }
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    addItem() {
      this.form.Items.push(this.newItem);
      this.newItem = {
        Description: "",
        Quantity: "",
        Unit: "",
        Price: ""
      };
    },
    autoAddItem() {
      if (
        this.newItem.Description !== "" &&
        this.newItem.Quantity !== "" &&
        this.newItem.Unit !== "" &&
        this.newItem.Price !== ""
      )
        this.addItem();
    },
    confirmDeleteItem(item) {
      let self = this;
      Swal.fire({
        //title: 'Are you sure?',
        html: "Are you sure you want delete this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          let array = self.form.Items;
          const index = array.indexOf(item);
          if (index > -1) {
            array.splice(index, 1);
          }
        }
      });
    },
    addOscaPwd() {}
  }
};
</script>
